// src/components/services/FestivalThali.jsx
import ServicePage from "../Common/ServicePage";

// Festival Special Thali specific services
const festivalThaliServices = [
  { 
    id: 1, 
    name: 'Navratri Thali', 
    provider: 'Festive Flavors', 
    image: 'https://placehold.co/600x400?text=Navratri+Thali', 
    rating: 4.90, 
    reviews: 800, 
    price: 499, 
    category: 'Navratri Special' 
  },
  { 
    id: 2, 
    name: 'Diwali Thali', 
    provider: 'Diwali Delights', 
    image: 'https://placehold.co/600x400?text=Diwali+Thali', 
    rating: 4.95, 
    reviews: 1200, 
    price: 699, 
    category: 'Diwali Special' 
  },
  { 
    id: 3, 
    name: 'Pongal Thali', 
    provider: 'Pongal Specials', 
    image: 'https://placehold.co/600x400?text=Pongal+Thali', 
    rating: 4.87, 
    reviews: 600, 
    price: 399, 
    category: 'Pongal Special' 
  },
  { 
    id: 4, 
    name: 'Eid Special Thali', 
    provider: 'Eid Feast', 
    image: 'https://placehold.co/600x400?text=Eid+Thali', 
    rating: 4.88, 
    reviews: 550, 
    price: 599, 
    category: 'Eid Special' 
  },
  { 
    id: 5, 
    name: 'Christmas Thali', 
    provider: 'Christmas Cheer', 
    image: 'https://placehold.co/600x400?text=Christmas+Thali', 
    rating: 4.92, 
    reviews: 450, 
    price: 749, 
    category: 'Christmas Special' 
  },
  { 
    id: 6, 
    name: 'Holi Special Thali', 
    provider: 'Holi Happiness', 
    image: 'https://placehold.co/600x400?text=Holi+Thali', 
    rating: 4.85, 
    reviews: 400, 
    price: 449, 
    category: 'Holi Special' 
  },
  { 
    id: 7, 
    name: 'Ganesh Chaturthi Thali', 
    provider: 'Ganesh Specials', 
    image: 'https://placehold.co/600x400?text=Ganesh+Thali', 
    rating: 4.89, 
    reviews: 350, 
    price: 549, 
    category: 'Ganesh Special' 
  },
  { 
    id: 8, 
    name: 'Onam Sadya Thali', 
    provider: 'Onam Feast', 
    image: 'https://placehold.co/600x400?text=Onam+Thali', 
    rating: 4.93, 
    reviews: 300, 
    price: 399, 
    category: 'Onam Special' 
  },
  { 
    id: 9, 
    name: 'Durga Puja Bhog Thali', 
    provider: 'Puja Specials', 
    image: 'https://placehold.co/600x400?text=Durga+Puja+Thali', 
    rating: 4.86, 
    reviews: 280, 
    price: 449, 
    category: 'Durga Puja Special' 
  },
  { 
    id: 10, 
    name: 'Makar Sankranti Thali', 
    provider: 'Sankranti Delights', 
    image: 'https://placehold.co/600x400?text=Sankranti+Thali', 
    rating: 4.84, 
    reviews: 320, 
    price: 379, 
    category: 'Sankranti Special' 
  },
  { 
    id: 11, 
    name: 'Raksha Bandhan Thali', 
    provider: 'Rakhi Specials', 
    image: 'https://placehold.co/600x400?text=Rakhi+Thali', 
    rating: 4.81, 
    reviews: 250, 
    price: 429, 
    category: 'Rakhi Special' 
  },
  { 
    id: 12, 
    name: 'Janmashtami Thali', 
    provider: 'Janmashtami Feast', 
    image: 'https://placehold.co/600x400?text=Janmashtami+Thali', 
    rating: 4.87, 
    reviews: 380, 
    price: 469, 
    category: 'Janmashtami Special' 
  }
];

const festivalThaliCategories = ['Navratri Special', 'Diwali Special', 'Pongal Special', 'Eid Special', 'Christmas Special', 'Holi Special', 'Ganesh Special', 'Onam Special', 'Durga Puja Special', 'Sankranti Special', 'Rakhi Special', 'Janmashtami Special'];

const packages = [
  { id: 1, title: "Navratri Thali", rating: "4.90 (800 reviews)", price: 499, originalPrice: 599, icon: "🕌" },
  { id: 2, title: "Diwali Thali", rating: "4.95 (1,200 reviews)", price: 699, originalPrice: 899, icon: "🎇" },
  { id: 3, title: "Pongal Thali", rating: "4.87 (600 reviews)", price: 399, originalPrice: 499, icon: "🍚" },
];

const miniServices = [
  { id: 101, title: "Extra Sweet Box", price: 199, icon: "🍬" },
  { id: 102, title: "Extra Snacks Pack", price: 149, icon: "🍿" },
  { id: 103, title: "Custom Add-on", price: 249, icon: "➕" },
];

export default function FestivalThali() {
  return (
    <ServicePage
      serviceName="snacks-savories"
      packages={packages}
      miniServices={miniServices}
      customServices={festivalThaliServices}
      customCategories={festivalThaliCategories}
      isCustomService={true}
    />
  );
}